/**
 * @file index.tsx
 *
 * @fileoverview Renders breadcrumbs component.
 */
import { cva, VariantProps } from "class-variance-authority";
import { ReactNode } from "react";
import ArrowRightIcon from "@jq-icons/ArrowRight";
import styles from "./breadcrumbs.module.scss";

const breadcrumb = cva([styles.breadcrumb], {
  variants: {
    isActive: {
      true: styles.breadcrumbActive,
    },
    isLast: { false: styles.breadcrumbNotLast },
  },
  defaultVariants: {
    isActive: false,
    isLast: false,
  },
});

export function Breadcrumb({
  children,
  isActive = false,
  isLast = false,
}: VariantProps<typeof breadcrumb> & { children: ReactNode }) {
  return (
    <li
      className={breadcrumb({ isLast, isActive })}
      {...(isActive && { "aria-current": "page" })}
    >
      {children}
      {!isLast && <ArrowRightIcon height="20" width="20" />}
    </li>
  );
}

export function BreadcrumbsWrapper({ children }: { children: ReactNode }) {
  return (
    <nav aria-label="Breadcrumb">
      <ol className={styles.breadcrumbsWrapper}>{children}</ol>
    </nav>
  );
}
